// @flow
import createLoader from 'modules/createLoader';

const loader = createLoader('root', {
  subModules: [
    () => import('modules/advertiser/bootstrap'),
    () => import('modules/auth/bootstrap'),
    () => import('modules/domain/bootstrap'),
    () => import('modules/order/bootstrap'),
    () => import('modules/payment/bootstrap'),
    () => import('modules/preland/bootstrap'),
    () => import('modules/profile/bootstrap'),
    () => import('modules/record/bootstrap'),
    () => import('modules/router/bootstrap'),
    () => import('modules/sign-up/bootstrap'),
    () => import('modules/stats/bootstrap'),
    () => import('modules/voucher/bootstrap'),
    () => import('modules/autostart/bootstrap'),
    () => import('modules/autofarm/bootstrap'),
  ],
});

export default loader.start;



// WEBPACK FOOTER //
// ./src/bootstrap.js